<ng-container [formGroup]="form">
  <div class="row" *ngIf="variant === 'select'">
    <label for="c24Id">Antragsnummer</label>
    <div class="selectWrapper">
      <select
        formControlName="c24Id"
        id="c24Id"
        [compareWith]="compareTransactionOptions"
      >
        <option [ngValue]="null" disabled>Bitte wählen Sie einen Antrag</option>
        <option *ngFor="let option of options" [ngValue]="option">
          {{ option.label }}
        </option>
      </select>
      <svg-icon
        src="/resultpage/assets/icons/Chevron_Arrow.svg"
        [ngClass]="['arrowIcon']"
        [svgStyle]="{ 'width.px': 14, 'height.px': 14 }"
      ></svg-icon>
    </div>
  </div>

  <div class="row" *ngIf="variant === 'text'">
    <label for="c24Id">Antragsnummer</label>
    <input
      type="text"
      formControlName="c24Id"
      placeholder="Antragsnummer"
      id="c24Id"
    />
  </div>
</ng-container>
